var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFetImg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 88,
    viewBox: "0 0 132 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    width: 130.583,
    height: 87.9271,
    rx: 11.5157,
    fill: "#FFEDD1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.4102 73.0005C82.7026 73.0005 95.9102 59.7929 95.9102 43.5005C95.9102 27.2081 82.7026 14.0005 66.4102 14.0005C50.1178 14.0005 36.9102 27.2081 36.9102 43.5005C36.9102 59.7929 50.1178 73.0005 66.4102 73.0005Z",
    fill: "#4B5896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4104 14.0005V73.0005C82.7022 73.0005 95.9104 59.7923 95.9104 43.5005C95.9104 27.2087 82.7022 14.0005 66.4104 14.0005Z",
    fill: "#656FAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7226 49.1328H58.7975L64.5535 34.4888H67.5864V52.5114H65.1423V39.006L65.0686 38.9933L59.6111 52.5114H57.9183L52.2983 38.545L52.2234 38.5577V52.5114H49.785V34.4888H52.9909L58.7226 49.1328ZM74.2458 50.6055H83.0348V52.5114H71.8075V34.4888H74.2458V50.6055Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white",
    transform: "translate(36.9102 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetImg5);
export default __webpack_public_path__ + "static/media/fet-img (5).0f3eb0e37c2f1b2b6d196afc800e52c3.svg";
export { ForwardRef as ReactComponent };